<template>
    <div class="px-4 py-4 sm:px-6">
        <div class="flex items-center gap-3">
            <div class="min-w-32">
                <p class="text-sm font-medium text-midea-text truncate">
                MODEL {{ data.DeviceModel ? data.DeviceModel.name : '"' + data.model + '"' }}
                </p>
                <div class="text-sm font-medium">
                    S/N {{data.serial}}
                </div>
                <div class="flex gap-2">
                    <div class="flex">
                        <OfficeBuildingIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
                        <p class="text-sm font-light text-gray-600 truncate">
                        {{ data.Company.name }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { OfficeBuildingIcon,  } from '@heroicons/vue/solid'

export default {
    components: { OfficeBuildingIcon,  },
    props: [
        'data'
    ],
    computed: {
        initials: function() { return this.data.firstName.toUpperCase().charAt(0) + this.data.lastName.toUpperCase().charAt(0) }
    }
}
</script>